export default "__VITE_ASSET__863e387d__"